<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div v-if="loadingOverlay === true">
        <div class="lds-dual-ring"></div>
      </div>
    </div>
    <div v-if="campaigns !== null">
      <div class="row">
        <div class="col-md-12">
          <p-button outline type="info" size="sm" round @click="$router.go(-1)">
            <i class="fa fa-chevron-circle-left"></i>
            Back
          </p-button>
        </div>
      </div>

      <h4>My Collaborations</h4>
      <div class="card">
        <div v-if="campaigns.length < 1" style="padding: 10px;">
          <h4>No campaigns</h4>
        </div>
        <div v-else style="padding: 25px;">
          <el-table :data="campaigns">
            <el-table-column label="Brand">
              <template slot-scope="props">
                <div style="text-align: center;">
                  <span v-if="typeof props.row.client.instagram !== 'undefined'">
                    <img :src="props.row.client.instagram.profilePic" class="influencer-img" alt />
                  </span>

                  <br />
                  {{props.row.client.businessName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Name" property="name" width="150px"></el-table-column>
            <el-table-column label="Description" property="campaignDescription"></el-table-column>

            <el-table-column label="Actions">
              <template slot-scope="props">
                <p-button
                  class="button-space"
                  link
                  type="info"
                  size="sm"
                  round
                  outline
                  @click="$router.push('/influencer/collaboration/detail/'+props.row.influencer.influencerId)"
                >Details</p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import {
  influencerCollaborationListApi,
  userLoadApi,
} from "@/config/appSettings";
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    loadingOverlay: false,
    campaigns: null,

    isTeam: null,
    isClient: null,
    isInfluencer: null,
  }),
  name: "InfluencerCampaignList",
  methods: {
    async loadCampaignList() {
      try {
        this.loadingOverlay = true;
        console.log("CAMPAIGN ID:", this.$route.params.clientId);
        if (this.isTeam == true) {
          // NEED TO PERFORM SEPARATE LOOKUP FOR PROFILE
        }
        if (this.isInfluencer === true) {
        }
        let influencerCampaignLoadUrl = `${influencerCollaborationListApi}/?usertoken=${this.auth}&instagram=${this.$route.params.instagramId}`;
        let influencerCollabList = await axios.get(influencerCampaignLoadUrl);
        console.log("CAMPAIGN DATA: ", influencerCollabList.data);
        if (influencerCollabList.data.success === true) {
          this.campaigns = influencerCollabList.data.result;
          this.loadingOverlay = false;
        }
      } catch (err) {
        console.log("CAMPAIGN LIST ERROR: ", err);
      }
    },
    async setProfileType() {
      try {
        console.log("PROFILE STORE:", this.profileStore);
        if (
          this.profileStore != false &&
          typeof this.profileStore !== "undefined"
        ) {
          if (this.profileStore.isTeam == true) {
            this.isTeam = true;
          }
        }
      } catch (err) {
        console.log("ERROR:", err);
      }

      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      console.log("PROFILE STORE MAIN:", this.profileStore);
      if (
        this.profileStore == false ||
        typeof this.profileStore == "undefined"
      ) {
        let profileLoadResponse = await axios.get(`${userLoadApi}${this.auth}`);
        console.log("PROFILE DATA MAIN:", profileLoadResponse.data);
        if (profileLoadResponse.data.success === true) {
          this.profileData = profileLoadResponse.data.result;
          if (this.profileData.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (this.profileData.profileTypes.length > 0) {
              if (this.profileData.profileTypes.indexOf("influencer") !== -1) {
                this.isInfluencer = true;
              }
              if (this.profileData.profileTypes.indexOf("client") !== -1) {
                this.isClient = true;
              }
            }
          } catch (err) {
            console.log("ERROR:", err);
          }
        }
      }
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadCampaignList();
    this.setProfileType();
  },
};
</script>

<style scoped>
.influencer-img {
  width: 50px;
  margin: 10px;
  border-radius: 5px;
}
</style>